<!-- 微官网页面 -->
<template>
  <div
    class="website_page"
    :style="{
      backgroundColor: `${this.pageOption.config.style.type === 'color' ? this.pageOption.config.style.bgColor : ''}`,
      backgroundImage: `url(${this.pageOption.config.style.type === 'image' ? encodeURI(this.pageOption.config.style.bgImg) : ''})`,
    }"
  >
    <div
      class="website_body_wrap"
      :style="{
        padding: `${this.pageOption.config.style.padding ? this.pageOption.config.style.padding + 'px' : '0px' }`
      }"
    >
      <!-- 语种选择 -->
      <WebHeader
        v-if="pageOption.language.show"
        :list="pageOption.language.options.list"
        :style="pageOption.language.options.style"
        @listenHandlePickLang="wannaPickLang"
      />
      <!-- 图片轮播 -->
      <WebSwipe
        v-if="pageOption.swiper.show"
        @listenHiddenCount="hiddenCount"
        :swiperOption="pageOption.swiper"
        :countOption="pageOption.count"
      />
      <!-- 导航部分 -->
      <component
        v-bind:is="currentComponent"
        :options="pageOption.navigation"
        :isBottomBtn="pageOption.bottombtn.show"
        :isBottomStatic="pageOption.registerNumber.show || pageOption.pageView.show"
        :numSize="!(pageOption.registerNumber.options.style.numSize < pageOption.pageView.options.style.numSize) ? pageOption.registerNumber.options.style.numSize : pageOption.pageView.options.style.numSize"
        :isFixedFooter="pageOption.fixedFooter ? pageOption.fixedFooter.show : false"
        :footerHeight="pageOption.fixedFooter ? pageOption.fixedFooter.options.style.wrapHeight : 50"
      />
      <!-- <WebTemplate3 :options="pageOption.navigation" /> -->

      <!-- 底部固定内容 -->
      <div
        v-if="false"
        class="fixed_botm_wrap"
      >
        <div class="fixed_botm_statis">
          <!-- 注册人数 -->
          <Enrollment
            v-if="pageOption.registerNumber.show"
            :options="pageOption.registerNumber.options"
            :number="enrollment"
          />
          <!-- 浏览统计 -->
          <PageView
            v-if="pageOption.pageView.show"
            :options="pageOption.pageView.options"
            :number="pageview"
          />
        </div>

        <!-- 底部固定按钮 -->
        <WebBottomBtn
          v-if="pageOption.bottombtn.show"
          :options="pageOption.bottombtn.options"
        />
        <!-- 底部导航 -->
        <WebFixedFooter
          v-if="pageOption.fixedFooter && pageOption.fixedFooter.show"
          :options="pageOption.fixedFooter.options"
        />
      </div>

    </div>

    <!-- 底部固定内容 -->
    <div class="fixed_botm_wrap">
      <div class="fixed_botm_statis">
        <!-- 注册人数 -->
        <Enrollment
          v-if="pageOption.registerNumber.show"
          :options="pageOption.registerNumber.options"
          :number="enrollment"
        />
        <!-- 浏览统计 -->
        <PageView
          v-if="pageOption.pageView.show"
          :options="pageOption.pageView.options"
          :number="pageview"
        />
      </div>

      <!-- 底部固定按钮 -->
      <WebBottomBtn
        v-if="pageOption.bottombtn.show"
        :options="pageOption.bottombtn.options"
      />
      <!-- 底部导航 -->
      <WebFixedFooter
        v-if="pageOption.fixedFooter && pageOption.fixedFooter.show"
        :options="pageOption.fixedFooter.options"
      />
    </div>

    <!-- 语种待选列表 -->
    <!-- 将待选列表放置在WebHeader组件时，
      iPhone上显示异常 -->
    <van-action-sheet
      class="lang_action_sheet"
      v-model="show"
      :actions="pageOption.language.options.list"
      @select="onSelect"
    />

    <!-- 加载中 -->
    <div
      v-show="loading"
      class="loading_wrap"
    >
      <van-loading
        class="loading_icon"
        color="#1989fa"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { ActionSheet } from 'vant'

Vue.use(ActionSheet)

import WebHeader from '@c/website/WebHeader'
import WebSwipe from '@c/website/WebSwipe'
import WebBottomBtn from '@c/website/WebBottomBtn'
import WebFixedFooter from '@c/website/WebFixedFooter'
import Enrollment from '@c/website/Enrollment'
import PageView from '@c/website/PageView'
import { GetWxshareConfig } from '@a/js/api/public'
import { GetWebsiteOptions, GetStatistics } from '@a/js/api/website'
import { SetWechatShare } from '@a/js/utils'
import { Base64 } from 'js-base64'
import wx from 'weixin-js-sdk'
import apiObj from '@a/js/api.js'

export default {
  name: 'Website',
  data() {
    return {
      show: false,
      pageOption: {
        config: {
          style: {},
        },

        language: {
          show: false,
          options: {
            style: {},
            list: [],
          },
        },

        swiper: {
          show: false,
          options: {
            play: {},
            data: {
              compatible: false,
              compatibleType: 'small',
              common: [],
              small: [],
              middle: [],
              large: [],
            },
          },
        },

        count: {
          show: false,
          options: {
            style: {},
            data: {
              endTime: 0,
              format: {},
            },
          },
        },

        navigation: {
          show: false,
          type: '',
          name: '',
          options: {
            style: {},
            list: [],
          },
        },

        bottombtn: {
          show: false,
          options: {
            style: {},
            data: {},
          },
        },

        registerNumber: {
          show: false,
          options: {
            style: {
              bgColor: 'rgba(255,0,0,0.05)',
              txtColor: '#000',
              numColor: '#ff9621',
              preSize: 12,
              numSize: 16,
            },
            data: {
              preText: '现已报名',
              base: 100
            }
          }
        },

        pageView: {
          show: false,
          options: {
            style: {
              bgColor: 'rgba(255,0,0,0.05)',
              txtColor: '#000',
              numColor: '#ff9621',
              preSize: 12,
              numSize: 16,
            },
            data: {
              preText: '现已报名',
              base: 100
            }
          }
        },

        fixedFooter: {
          "show": false,
          "options": {
            "info": {
              "left": [],
              "center": {
                "id": "iaeol0lo8",
                "url": "",
                "edit": false,
                "icon": {
                  "name": "ri-file-list-3-line",
                  "show": true,
                  "color": "rgba(0,98,222,1)"
                },
                "rank": 5,
                "text": {
                  "name": "首页",
                  "show": true,
                  "color": "#06f"
                },
                "style": {
                  "bgImg": "http://cdn.bhykf.com/dev/business/f1746935ddcfbd37/w18465b516ac39bb/website/website_nav_bgImg/1668779867648_home.png",
                  "bgType": "image",
                  "bgColor": "rgba(245,245,245,0)"
                },
                "bindUrl": ""
              },
              "right": []
            },
            "style": {
              "bgColor": "#fff",
              "bgImg": "",
              "bgType": "color"
            }
          }
        }
      },
      params: {},
      loading: true,
      userid: undefined,
      enrollment: 0,
      pageview: 0
    }
  },

  components: {
    WebHeader,
    WebSwipe,
    WebBottomBtn,
    Enrollment,
    PageView,
    WebFixedFooter,
    navigation1(resolve) {
      require(['@c/website/template/WebNavigation1'], resolve)
    },
    navigation2(resolve) {
      require(['@c/website/template/WebNavigation2'], resolve)
    },
    navigation3(resolve) {
      require(['@c/website/template/WebNavigation3'], resolve)
    },
    navigation4(resolve) {
      require(['@c/website/template/WebNavigation4'], resolve)
    },
  },

  computed: {
    currentComponent() {
      return this.pageOption.navigation.name
        ? this.pageOption.navigation.name
        : 'navigation1'
    },
  },

  methods: {
    // 展示语言选择框
    wannaPickLang() {
      this.show = true
    },
    // 选择语言
    onSelect(item) {
      if (item.type !== 'default') {
        window.location.href = item.url
      }
      this.show = false
    },
    // 获取数据请求参数
    getParams() {
      return new Promise(resolve => {
        this.params = this.$route.params
        resolve()
      })
    },
    // 页面初始化获取微信分享配置
    InitGetWxShareConfig() {
      let href = window.location.href.split('#')[0]
      let resdata = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        app_name: this.$AppName,
        url: Base64.encode(href),
      }
      GetWxshareConfig(resdata)
        .then((res) => {
          // console.log(res)
          if (res.data.config.appId) {
            let imgUrl = ''
            if (res.data.info.img.length > 0) {
              imgUrl = apiObj.VUE_APP_BASE_CDN + res.data.info.img
            }
            SetWechatShare(wx, res.data, href, imgUrl)
          }
        })
        .catch(() => { })
    },
    // 获取页面配置信息
    initWebsiteOptions() {
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        app_name: this.$AppName,
        data_uid: this.userid
      }
      GetWebsiteOptions(data)
        .then((res) => {
          // let configs = res.data.config
          // configs.count.options.data.startTime = res.data.time
          // this.pageOption = configs
          // this.loading = false

          this.JudgeIsNeedVerify(res.data)
        })
        .catch(() => { })
    },
    // 初始化页面信息
    InitPageData(data) {
      // console.log(data)
      let configs = data.config
      configs.count.options.data.startTime = data.time
      configs.count.options.data.preText = configs.count.options.data.preText ? configs.count.options.data.preText : ''
      let arr = [
        {
          id: 'month',
          label: '月',
          show: true
        },
        {
          id: 'day',
          label: '日',
          show: true
        },
        {
          id: 'hour',
          label: '时',
          show: true
        },
        {
          id: 'minute',
          label: '分',
          show: true
        },
        {
          id: 'second',
          label: '秒',
          show: true
        },
      ]
      configs.count.options.data.content = configs.count.options.data.content ? configs.count.options.data.content : arr
      if (!configs.registerNumber || !('show' in configs.registerNumber)) {
        configs.registerNumber = {
          show: false,
          options: {
            style: {
              bgColor: 'rgba(255,0,0,0.05)',
              txtColor: '#000',
              numColor: '#ff9621',
              preSize: 12,
              numSize: 16,
            },
            data: {
              preText: '现已报名',
              base: 100
            }
          }
        }
      }
      if (!configs.pageView || !('show' in configs.pageView)) {
        configs.pageView = {
          show: false,
          options: {
            style: {
              bgColor: 'rgba(255,0,0,0.05)',
              txtColor: '#000',
              numColor: '#ff9621',
              preSize: 12,
              numSize: 16,
            },
            data: {
              preText: '当前热度',
              base: 100
            }
          }
        }
      }

      this.pageOption = configs
      // console.log(configs)

      // this.pageOption = {
      //   "config": {
      //     "style": {
      //       "bgColor": "#e6f7ff",
      //       "bgImg": "",
      //       "type": "color",
      //       "padding": 16
      //     }
      //   },
      //   "bottombtn": {
      //     "show": false,
      //     "options": {
      //       "data": {
      //         "bindUrl": "",
      //         "text": "立即报名",
      //         "url": ""
      //       },
      //       "style": {
      //         "bgColor": "rgba(5,15,51,0.8)",
      //         "color": "#ddc89d"
      //       }
      //     }
      //   },
      //   "count": {
      //     "show": false,
      //     "options": {
      //       "data": {
      //         "endTime": 0,
      //         "format": {
      //           "day": "日",
      //           "hour": "时",
      //           "minute": "分",
      //           "month": "月",
      //           "second": "秒"
      //         }
      //       },
      //       "style": {
      //         "bgColor1": "rgba(5,15,51,1)",
      //         "bgColor2": "rgba(5,15,51,0)",
      //         "bgSty": "sty2",
      //         "color": "#fff"
      //       }
      //     }
      //   },
      //   "language": {
      //     "show": false,
      //     "options": {
      //       "list": [
      //         {
      //           "name": "中文",
      //           "type": "default",
      //           "url": "当前页面"
      //         }
      //       ],
      //       "style": {
      //         "color": "#fff"
      //       }
      //     }
      //   },
      //   "swiper": {
      //     "show": true,
      //     "options": {
      //       "data": {
      //         "compatible": false,
      //         "compatibleType": "small",
      //         "large": [],
      //         "middle": [],
      //         "small": [],
      //         "common": [
      //           {
      //             "id": "sx8g4c831",
      //             "rank": 1,
      //             "url": "http://cdn.bhykf.com/dev/business/f1746935ddcfbd37/w18465b516ac39bb/website/swiper_img/1668781226303_header_03.png"
      //           }
      //         ]
      //       },
      //       "play": {
      //         "autoplay": 4000,
      //         "duration": 800,
      //         "indicatorColor": "#fff",
      //         "indicators": true,
      //         "loop": true
      //       },
      //       "style": {
      //         "type": "color",
      //         "bgColor": "#fff",
      //         "bgImg": "",
      //         "padding": 16,
      //         "borderRadius": 4
      //       }
      //     }
      //   },
      //   "navigation": {
      //     "name": "navigation4",
      //     "show": true,
      //     "type": "template",
      //     "options": {
      //       "navigation4_1": {
      //         "name": "navigation4_1",
      //         "list": [
      //           {
      //             "id": "sx8gb0kye",
      //             "url": "https://www.baidu.com",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-article-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 1,
      //             "text": {
      //               "name": "大会介绍",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "eqsph4hw9",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-survey-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 2,
      //             "text": {
      //               "name": "大会议程",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "lu0kwqwyz",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-user-2-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 3,
      //             "text": {
      //               "name": "嘉宾介绍",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "b76rtbaga",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-road-map-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 4,
      //             "text": {
      //               "name": "时间地点",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "iaeol0lo8",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-file-list-3-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 5,
      //             "text": {
      //               "name": "报名购票",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "lu0maua2w",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-image-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 6,
      //             "text": {
      //               "name": "大会相册",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "pdmk0nm56",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-team-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 7,
      //             "text": {
      //               "name": "合作伙伴",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "pdmk0nwof",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-chat-smile-3-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 8,
      //             "text": {
      //               "name": "联系我们",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           }
      //         ],
      //         "style": {
      //           "bgType": "color",
      //           "bgImg": "",
      //           "bgColor": "#fff",
      //           "borderRadius": 4,
      //           "marginTop": 20
      //         }
      //       },
      //       "navigation4_2": {
      //         "name": "navigation4_2",
      //         "list": [
      //           {
      //             "id": "sx8gb1kye",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-article-line",
      //               "show": false,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 1,
      //             "text": {
      //               "name": "大会介绍",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(255,255,255,1)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "eqsph3hw9",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-survey-line",
      //               "show": false,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 2,
      //             "text": {
      //               "name": "大会议程",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(255,255,255,1)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "luwkwqwyz",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-user-2-line",
      //               "show": false,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 3,
      //             "text": {
      //               "name": "嘉宾介绍",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(255,255,255,1)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "b7srtbaga",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-road-map-line",
      //               "show": false,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 4,
      //             "text": {
      //               "name": "时间地点",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(255,255,255,1)"
      //             },
      //             "bindUrl": ""
      //           }
      //         ],
      //         "style": {
      //           "bgType": "color",
      //           "bgImg": "",
      //           "bgColor": "rgba(255,255,255,0)",
      //           "borderRadius": 4,
      //           "marginTop": 20
      //         }
      //       }
      //     }
      //   },
      //   "registerNumber": {
      //     "show": false,
      //     "options": {
      //       "style": {
      //         "bgColor": "rgba(255,0,0,0.05)",
      //         "txtColor": "#000",
      //         "numColor": "#ff9621",
      //         "preSize": 12,
      //         "numSize": 16
      //       },
      //       "data": {
      //         "preText": "现已报名",
      //         "base": 100
      //       }
      //     }
      //   },
      //   "pageView": {
      //     "show": false,
      //     "options": {
      //       "style": {
      //         "bgColor": "rgba(255,0,0,0.05)",
      //         "txtColor": "#000",
      //         "numColor": "#ff9621",
      //         "preSize": 12,
      //         "numSize": 16
      //       },
      //       "data": {
      //         "preText": "当前热度",
      //         "base": 100
      //       }
      //     }
      //   },
      //   "fixedFooter": {
      //     "show": true,
      //     "options": {
      //       "info": {
      //         "left": [
      //           {
      //             "id": "sx8gb0kye",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-article-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 1,
      //             "text": {
      //               "name": "大会介绍",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "eqsph4hw9",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-survey-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 2,
      //             "text": {
      //               "name": "大会议程",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           }
      //         ],
      //         "center": {
      //           "id": "iaeol0lo8",
      //           "url": "",
      //           "edit": false,
      //           "icon": {
      //             "name": "ri-file-list-3-line",
      //             "show": true,
      //             "color": "rgba(0,98,222,1)"
      //           },
      //           "rank": 5,
      //           "text": {
      //             "name": "首页",
      //             "show": true,
      //             "color": "#06f"
      //           },
      //           "style": {
      //             "bgImg": "http://cdn.bhykf.com/dev/business/f1746935ddcfbd37/w18465b516ac39bb/website/website_nav_bgImg/1668779867648_home.png",
      //             "bgType": "image",
      //             "bgColor": "rgba(245,245,245,0)"
      //           },
      //           "bindUrl": ""
      //         },
      //         "right": [
      //           {
      //             "id": "lu0kwqwyz",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-user-2-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 3,
      //             "text": {
      //               "name": "嘉宾介绍",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           },
      //           {
      //             "id": "b76rtbaga",
      //             "url": "",
      //             "edit": false,
      //             "icon": {
      //               "name": "ri-road-map-line",
      //               "show": true,
      //               "color": "rgba(0,98,222,1)"
      //             },
      //             "rank": 4,
      //             "text": {
      //               "name": "时间地点",
      //               "show": true,
      //               "color": "rgba(91,91,91,1)"
      //             },
      //             "style": {
      //               "bgImg": "",
      //               "bgType": "color",
      //               "bgColor": "rgba(245,245,245,0)"
      //             },
      //             "bindUrl": ""
      //           }
      //         ]
      //       },
      //       "style": {
      //         "bgColor": "#fff",
      //         "bgImg": "",
      //         "bgType": "color"
      //       }
      //     }
      //   }
      // }
      if (configs.registerNumber.show || configs.pageView.show) {
        this.GetRegisterNumber()
      }
      this.loading = false
    },
    // 获取本地数据
    GetLocalData() {
      return new Promise(resolve => {
        resolve(this.$storeLocal.get('verify_data'))
      })
    },
    // 判断是否已经登录
    JudgeIsLogin(verify_data) {
      return new Promise((resolve, reject) => {
        if (verify_data && verify_data.dataid && verify_data.accountid === this.params.accountid && verify_data.projectid === this.params.projectid && verify_data.type === 'website') {
          this.userid = verify_data.dataid
          resolve()
        } else {
          reject()
        }
      })
    },
    // 判断是否开始登录验证
    JudgeIsNeedVerify(options) {
      if (options.config.senior && options.config.senior.verify) {
        if (this.userid) {
          this.InitPageData(options)
        } else {
          let url = apiObj.VUE_APP_BASE_SERVE + 'center/verify/' + this.params.accountid + '/' + this.params.projectid + '/website'
          window.location.href = url
        }
      } else {
        this.InitPageData(options)
      }
    },
    // 隐藏倒计时
    hiddenCount() {
      this.pageOption.count.show = false
    },
    // 获取注册数据
    GetRegisterNumber() {
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid
      }
      GetStatistics(data).then(res => {
        console.log(res)
        this.enrollment = res.data.register
        this.pageview = res.data.pv
      }).catch(() => { })
    }
  },

  //通过两个钩子函数来设置页面尺寸
  beforeCreate: function () {
    // 获取访问页面设备类型
    if (
      !/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)
    ) {
      // document.getElementsByTagName('body')[0].className = 'abs_pc_style'
      document.getElementsByTagName('body')[0].className = ''
    }
  },
  beforeDestroy: function () {
    document.body.removeAttribute('class', 'abs_pc_style')
  },

  mounted() {
    this.getParams().then(() => {
      this.GetLocalData().then(verify_data => {
        this.JudgeIsLogin(verify_data).then(() => {
          this.initWebsiteOptions()
        }).catch(() => {
          this.initWebsiteOptions()
        })
      })
      this.InitGetWxShareConfig()
    })
  },
}
</script>

<style lang="less" scoped>
.website_page {
  position: relative;
  height: 100vh;
  background-repeat: no-repeat;
  // background-position: center;
  background-size: cover;
  .website_body_wrap {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    box-sizing: border-box;
  }
  .lang_action_sheet {
    max-height: 45%;
  }
  .loading_wrap {
    position: absolute;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    .loading_icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
  .fixed_botm_wrap {
    position: fixed;
    z-index: 98;
    left: 0;
    right: 0;
    bottom: 0;
    .fixed_botm_statis {
      display: flex;
      .ement_wrap {
        flex: 1;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
